export const getDateTimeFromTimeZone = ({ timeZone, noTime }) => {
  const localDateTime = new Date()
    .toLocaleString('pt-PT', { timeZone })
    .replace(/,/g, '');

  const [day, month, year, hours, minutes, seconds] =
    localDateTime.match(/\d+/g);

  if (noTime) return new Date(year, month - 1, day);

  return new Date(year, month - 1, day, hours, minutes, seconds);
};
